<template>
  <!--
      直接写在 index.html里：.nav样式position: fixed 正常固定在浏览器窗口最顶部
      迁移到 App.vue 组件模板内之后，fixed 导航跑到页面中间，无法钉在视口顶端
      原因：CSS规范：如果一个元素的任意祖先元素设置了 transform（不为 none），那么该元素的 position:fixed 将不再相对于浏览器视口定位，改为相对于这个带 transform 的祖先容器定位
      没迁移之前的index.html结构:.nav 的父链只有 body、html，没有任何 transform，fixed 参照浏览器窗口，表现正常
      放到 App.vue 内部时的 DOM 结构:<div id="app">-><div>-><div class="nav">导航</div>
        Vue 模板语法约束：<template> 必须有单个根标签，所以外层多套了一层 div；
        项目使用了路由 <transition> 做页面切换动画，组件运行时会给内部 DOM 自动生成 transform 属性；
        .nav 处于 #app 的内部子树，祖先链出现了非 none 的transform；
        触发 CSS 规则：fixed 不再参照浏览器窗口，改为参照这个带 transform 的容器，导航就卡在页面中间。
      Teleport 的作用：Vue 逻辑、响应式、接口请求依然保留在 Vue 组件内部，但是最终渲染出来的 DOM 节点，物理移动挂载到 <body> 的直接子节点，跳出 #app 的 DOM 子树-->
  <Teleport to="body">
    <laputa-header/>
    <!-- 这里自动渲染 Home 或者 Resume，二选一 -->
    <router-view v-slot="{ Component }">
      <component :is="Component"/>
    </router-view>
    <LaputaContactMe/>
    <LaputaSearchbar/>
    <LaputaEditProfile @success="store.dispatch('userInfo/refresh')"/>
    <laputa-footer/>
  </Teleport>
</template>

<script setup>
import LaputaHeader from "@/components/common/LaputaHeader.vue";
import LaputaFooter from "@/components/common/LaputaFooter.vue";
import LaputaContactMe from "@/components/common/LaputaContactMe.vue";
import LaputaEditProfile from "@/components/common/LaputaEditProfile.vue";
import store from "@/store";
import LaputaSearchbar from "@/components/common/LaputaSearchbar.vue";
// 接收Header传过来的按钮DOM元素
</script>
<style>
body {
  background: var(--laputa-body-background);
  display: flex;
  margin: auto;
  flex-direction: column;
  font-family: var(--font-family-primary);
  align-items: center;
}

body .need-padding {
  max-width: 1200px;
  width: 90%;
}

html {
  scrollbar-width: none;
}

</style>
